import { createContext, useContext } from 'react';
export const CopilotCollaborationContext = /*#__PURE__*/createContext(undefined);
export const useCopilotCollaborationContext = () => {
  return useContext(CopilotCollaborationContext);
};